var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { Loader } from '@ui';
import { Text } from '@ui/atoms/Text';
import { translate } from '@utils/i18n';
import { useIpAssistantSettings } from './hooks/useIpAssistantSettings';
import { useUpdateIpAssistantSettings } from './hooks/useUpdateIpAssistantSettings';
import { UserAccessSection } from './components/UserAccessSection';
import './SettingsStyles.scss';
const namespace = 'features.settings.ip_assistant';
function Settings({ ipAssistantAllowedUserIds: initialAllowedUserIds, ipAssistantAllowedTechnicianIds: initialAllowedTechnicianIds = [], ipAssistantMaxUsers: initialMaxUsers = 0 }) {
    var _a, _b, _c;
    const { data: settings, isLoading: isLoadingSettings } = useIpAssistantSettings();
    const mutation = useUpdateIpAssistantSettings();
    const allowedUserIds = (_a = settings === null || settings === void 0 ? void 0 : settings.ipAssistantAllowedUserIds) !== null && _a !== void 0 ? _a : initialAllowedUserIds;
    const allowedTechnicianIds = (_b = settings === null || settings === void 0 ? void 0 : settings.ipAssistantAllowedTechnicianIds) !== null && _b !== void 0 ? _b : initialAllowedTechnicianIds;
    const maxUsers = (_c = settings === null || settings === void 0 ? void 0 : settings.ipAssistantMaxUsers) !== null && _c !== void 0 ? _c : initialMaxUsers;
    const handleSaveUsers = (userIds, technicianIds) => __awaiter(this, void 0, void 0, function* () {
        yield mutation.mutateAsync({
            ip_assistant_allowed_user_ids: userIds,
            ip_assistant_allowed_technician_ids: technicianIds
        });
    });
    const pageTitle = (React.createElement(Text, { variant: "x-large", as: "h1" }, translate('title', { namespace })));
    if (isLoadingSettings) {
        return (React.createElement("div", { className: "workspace__major--form" },
            React.createElement("header", { className: "workspace__header--alt--sticky" },
                React.createElement("div", { className: "header__main" }, pageTitle)),
            React.createElement("div", { className: "ip-assistant-settings__loading" },
                React.createElement(Loader, { size: "48" }))));
    }
    return (React.createElement("div", { className: "workspace__major--form" },
        React.createElement("header", { className: "workspace__header--alt--sticky" },
            React.createElement("div", { className: "header__main" }, pageTitle)),
        React.createElement("section", { className: "ip-assistant-settings-container" },
            React.createElement(UserAccessSection, { allowedUserIds: allowedUserIds, allowedTechnicianIds: allowedTechnicianIds, maxUsers: maxUsers, onSave: handleSaveUsers, isSaving: mutation.isLoading }))));
}
export default Settings;
